import { getLDClient } from "../contexts/LaunchDarkly/ldClient";

/** LaunchDarkly flag routing a user's company match requests to RGIP. */
export const RGIP_COMPANY_MATCH_FLAG = "rgip-company-match";

/**
 * Headers asking piq's server to proxy this user's company match request to
 * rgip-company-match instead of legacy (piq routes/company-match-api.js).
 * Read per request, so a flag change applies without a reload. Without the
 * flag, or before LaunchDarkly is ready, nothing is sent and piq uses legacy.
 */
export function companyMatchRoutingHeaders(): Record<string, string> {
  return getLDClient()?.variation(RGIP_COMPANY_MATCH_FLAG, false) === true
    ? { "X-Company-Match": "rgip" }
    : {};
}
